import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

export type RegressionImpact = {
  affectedQUs: Array<{ id: string; color: string; totalHectares: number }>
  affectedPaddocks: string[]
  hectaresLost: number
}

type RegressionConfirmModalProps = {
  open: boolean
  impact: RegressionImpact
  isAdmin: boolean
  requiresAdminConfirmation: boolean
  onConfirm: () => void
  onCancel: () => void
}

const RegressionConfirmModal = ({
  open,
  impact,
  isAdmin,
  requiresAdminConfirmation,
  onConfirm,
  onCancel,
}: RegressionConfirmModalProps) => {
  const canConfirm = !requiresAdminConfirmation || isAdmin
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onCancel}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="warning" />
        Confirmación de regresión requerida
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            Esta operación marca lotes activos como <strong>regresados</strong> en Unidades de
            Cuantificación activas. Se perderán <strong>{impact.hectaresLost.toFixed(2)} ha</strong>{' '}
            acreditables.
          </Typography>

          <Box>
            <Typography gutterBottom variant="subtitle2">
              Unidades de Cuantificación afectadas
            </Typography>
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {impact.affectedQUs.map(qu => (
                <Chip
                  key={qu.id}
                  data-testid="qu-chip"
                  label={`${qu.totalHectares.toFixed(2)} ha`}
                  size="small"
                  sx={{ backgroundColor: qu.color, color: '#fff', fontWeight: 600 }}
                />
              ))}
            </Stack>
          </Box>

          <Typography variant="body2">
            Lotes afectados: <strong>{impact.affectedPaddocks.length} lotes</strong>
          </Typography>

          {requiresAdminConfirmation && !isAdmin && (
            <Typography color="text.secondary" variant="body2">
              Este cambio requiere confirmación de un administrador. Solicita aprobación a un
              usuario admin.
            </Typography>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button color="inherit" onClick={onCancel}>
          Cancelar
        </Button>
        {canConfirm && (
          <Button color="warning" variant="contained" onClick={onConfirm}>
            Confirmar regresión
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default RegressionConfirmModal
